import { ATTRIBUTI} from './TabellaAttributiTypes'

const initialState = {
    attributi: {
        state: false,
        value: ''
    }
}

const tabellaAttributi = (state = initialState, action) => {
    
    switch (action.type) {
        case ATTRIBUTI:
            
            return {
                attributi: action.load
            }
    
        default:
          return state
    }

}

export default tabellaAttributi;